// 组件库
import React from "react";

// 布局
import CommonLayout from "@/layouts/CommonLayout";

// 组件
import ProductCard from "@/components/cards/productCard";

export default function Index(props: any) {
  const CardItems = [
    { id: 1, title: "test1", desc: "这是测试数据11111" },
    { id: 2, title: "test2", desc: "这是测试数据22222" },
    { id: 3, title: "test3", desc: "这是测试数据33333" },
    { id: 4, title: "test4", desc: "这是测试数据44444" },
  ];
  return (
    <>
      <CommonLayout>
        <main className="relative bg-[#f5f6f7] min-h-screen">
          <div>
            <div className="mt-12 pointer-events-none absolute inset-0 hidden overflow-hidden lg:block">
              <svg
                className="absolute top-28 -left-20 rotate-1"
                width="332"
                height="222"
                viewBox="0 0 332 222"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_212_2517)">
                  <rect
                    x="20.547"
                    y="18.517"
                    width="290"
                    height="180"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <rect
                    x="20.547"
                    y="18.517"
                    width="290"
                    height="180"
                    rx="10"
                    stroke="#E3E5EA"
                  ></rect>
                </g>
                <path
                  opacity=".5"
                  stroke="#D2D5DA"
                  d="M70.547 156.017h220M70.547 106.017h220M70.547 56.017h220"
                ></path>
                <rect
                  opacity=".5"
                  x="40.547"
                  y="145.517"
                  width="19"
                  height="6"
                  rx="2"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".5"
                  x="40.547"
                  y="95.517"
                  width="19"
                  height="6"
                  rx="2"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".5"
                  x="40.547"
                  y="45.517"
                  width="19"
                  height="6"
                  rx="2"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".5"
                  x="82.547"
                  y="166.517"
                  width="19"
                  height="6"
                  rx="2"
                  fill="#D2D5DA"
                ></rect>
                <path
                  d="M81.547 140.517a4 4 0 0 1 4-4h15a4 4 0 0 1 4 4v15h-23v-15ZM117.547 123.517a4 4 0 0 1 4-4h15a4 4 0 0 1 4 4v32h-23v-32ZM153.547 68.517a4 4 0 0 1 4-4h15a4 4 0 0 1 4 4v87h-23v-87ZM188.547 99.517a4 4 0 0 1 4-4h15a4 4 0 0 1 4 4v56h-23v-56ZM225.547 123.517a4 4 0 0 1 4-4h15a4 4 0 0 1 4 4v32h-23v-32ZM261.547 116.517a4 4 0 0 1 4-4h15a4 4 0 0 1 4 4v39h-23v-39Z"
                  fill="#966CD7"
                ></path>
                <path
                  opacity=".5"
                  fill="#D2D5DA"
                  d="M91.547 156.517h1v5h-1z"
                ></path>
                <rect
                  opacity=".5"
                  x="118.547"
                  y="166.517"
                  width="19"
                  height="6"
                  rx="2"
                  fill="#D2D5DA"
                ></rect>
                <path
                  opacity=".5"
                  fill="#D2D5DA"
                  d="M127.547 156.517h1v5h-1z"
                ></path>
                <rect
                  opacity=".5"
                  x="154.547"
                  y="166.517"
                  width="19"
                  height="6"
                  rx="2"
                  fill="#D2D5DA"
                ></rect>
                <path
                  opacity=".5"
                  fill="#D2D5DA"
                  d="M163.547 156.517h1v5h-1z"
                ></path>
                <rect
                  opacity=".5"
                  x="190.547"
                  y="166.517"
                  width="19"
                  height="6"
                  rx="2"
                  fill="#D2D5DA"
                ></rect>
                <path
                  opacity=".5"
                  fill="#D2D5DA"
                  d="M199.547 156.517h1v5h-1z"
                ></path>
                <rect
                  opacity=".5"
                  x="226.547"
                  y="166.517"
                  width="19"
                  height="6"
                  rx="2"
                  fill="#D2D5DA"
                ></rect>
                <path
                  opacity=".5"
                  fill="#D2D5DA"
                  d="M235.547 156.517h1v5h-1z"
                ></path>
                <rect
                  opacity=".5"
                  x="262.547"
                  y="166.517"
                  width="19"
                  height="6"
                  rx="2"
                  fill="#D2D5DA"
                ></rect>
                <path
                  opacity=".5"
                  fill="#D2D5DA"
                  d="M271.547 156.517h1v5h-1z"
                ></path>
                <defs>
                  <filter
                    id="filter0_d_212_2517"
                    x=".047"
                    y=".017"
                    width="331"
                    height="221"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2517"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2517"
                      result="shape"
                    ></feBlend>
                  </filter>
                </defs>
              </svg>

              <svg
                className="absolute top-28 -right-20"
                width="332"
                height="222"
                viewBox="0 0 332 222"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_212_2607)">
                  <rect
                    x="109"
                    y="19"
                    width="70"
                    height="80"
                    rx="10"
                    fill="#F9FAFB"
                  ></rect>
                  <rect
                    x="109"
                    y="19"
                    width="70"
                    height="80"
                    rx="10"
                    stroke="#E3E5EA"
                  ></rect>
                </g>
                <g filter="url(#filter1_d_212_2607)">
                  <rect
                    x="187"
                    y="19"
                    width="70"
                    height="80"
                    rx="10"
                    fill="#F9FAFB"
                  ></rect>
                  <rect
                    x="187"
                    y="19"
                    width="70"
                    height="80"
                    rx="10"
                    stroke="#E3E5EA"
                  ></rect>
                </g>
                <g filter="url(#filter2_d_212_2607)">
                  <path
                    d="M31 19c-5.523 0-10 4.477-10 10v160c0 5.523 4.477 10 10 10h270c5.523 0 10-4.477 10-10V54c0-5.523-4.477-10-10-10H103a2 2 0 0 1-2-2V29c0-5.523-4.477-10-10-10H31Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M31 19c-5.523 0-10 4.477-10 10v160c0 5.523 4.477 10 10 10h270c5.523 0 10-4.477 10-10V54c0-5.523-4.477-10-10-10H103a2 2 0 0 1-2-2V29c0-5.523-4.477-10-10-10H31Z"
                    stroke="#E3E5EA"
                  ></path>
                </g>
                <defs>
                  <filter
                    id="filter0_d_212_2607"
                    x="88.5"
                    y=".5"
                    width="111"
                    height="121"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2607"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2607"
                      result="shape"
                    ></feBlend>
                  </filter>
                  <filter
                    id="filter1_d_212_2607"
                    x="166.5"
                    y=".5"
                    width="111"
                    height="121"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2607"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2607"
                      result="shape"
                    ></feBlend>
                  </filter>
                  <filter
                    id="filter2_d_212_2607"
                    x=".5"
                    y=".5"
                    width="331"
                    height="221"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2607"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2607"
                      result="shape"
                    ></feBlend>
                  </filter>
                </defs>
              </svg>

              <svg
                className="absolute top-16 right-[18%] rotate-1 hidden xl:block"
                width="332"
                height="214"
                viewBox="0 0 332 214"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_212_2660)">
                  <rect
                    x="21.479"
                    y="18.518"
                    width="290"
                    height="40"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <rect
                    x="21.479"
                    y="18.518"
                    width="290"
                    height="40"
                    rx="10"
                    stroke="#E3E5EA"
                  ></rect>
                </g>
                <g clip-path="url(#clip0_212_2660)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M42.229 27.518a.75.75 0 0 0-1.5 0v1.259c-.72.018-1.272.073-1.76.237a4.75 4.75 0 0 0-2.994 2.994c-.247.736-.247 1.618-.247 3v4.566c0 1.838 0 3.293.154 4.433.157 1.172.49 2.121 1.238 2.87.748.748 1.697 1.08 2.87 1.237 1.139.154 2.594.154 4.432.154h2.113c1.838 0 3.293 0 4.433-.154 1.172-.157 2.121-.49 2.87-1.238.748-.748 1.08-1.697 1.237-2.87.154-1.139.154-2.594.154-4.432v-2.113c0-1.838 0-3.293-.154-4.432-.157-1.173-.49-2.122-1.238-2.87-.748-.748-1.697-1.08-2.87-1.238-.232-.032-.478-.056-.738-.076v-1.327a.75.75 0 0 0-1.5 0v1.262c-.663-.012-1.392-.012-2.194-.012h-4.306v-1.25Zm6.5 3v-.237c-.653-.013-1.396-.013-2.25-.013h-4.25v.25a.75.75 0 0 1-1.5 0v-.24c-.627.017-.983.058-1.283.158a3.25 3.25 0 0 0-2.049 2.049c-.159.473-.168 1.086-.168 2.68v4.353c0 1.906.001 3.261.14 4.289.135 1.006.388 1.585.812 2.009.423.423 1.002.677 2.008.812 1.028.138 2.383.14 4.29.14h2c1.906 0 3.261-.002 4.289-.14 1.006-.135 1.585-.39 2.009-.812.423-.424.676-1.003.812-2.01.138-1.027.14-2.382.14-4.288v-2c0-1.907-.002-3.262-.14-4.29-.136-1.006-.39-1.585-.812-2.009-.424-.423-1.003-.676-2.01-.812-.17-.023-.349-.042-.538-.058v.169a.75.75 0 0 1-1.5 0Zm-8.25 3.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5h-10Zm2 4.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3-5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                    fill="#9DA3AE"
                  ></path>
                </g>
                <rect
                  opacity=".5"
                  x="73.478"
                  y="28.518"
                  width="108"
                  height="20"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <g filter="url(#filter1_d_212_2660)">
                  <rect
                    x="21.479"
                    y="66.518"
                    width="290"
                    height="124"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <rect
                    x="21.479"
                    y="66.518"
                    width="290"
                    height="124"
                    rx="10"
                    stroke="#E3E5EA"
                  ></rect>
                </g>
                <rect
                  opacity=".1"
                  x="34.478"
                  y="105.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="34.478"
                  y="144.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="73.478"
                  y="105.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="73.478"
                  y="144.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="112.479"
                  y="105.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="112.479"
                  y="144.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="151.479"
                  y="105.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="151.479"
                  y="144.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  x="190.479"
                  y="105.518"
                  width="30"
                  height="30"
                  rx="6"
                  fill="#fff"
                  stroke="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="190.479"
                  y="144.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="229.479"
                  y="105.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="229.479"
                  y="144.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="268.479"
                  y="105.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <rect
                  opacity=".1"
                  x="268.479"
                  y="144.518"
                  width="30"
                  height="30"
                  rx="4"
                  fill="#D2D5DA"
                ></rect>
                <path
                  d="M128.793 115.79v8.728h-1.321v-7.407h-.051l-2.088 1.364v-1.261l2.177-1.424h1.283Z"
                  fill="#797F8A"
                ></path>
                <path
                  d="M124.38 84.557v-1.04h6.192v1.04h-2.496v6.96h-1.203v-6.96h-2.493Z"
                  fill="#9CA0A9"
                ></path>
                <path
                  d="M127.476 163.637c-.611 0-1.151-.105-1.619-.315-.466-.211-.831-.5-1.096-.87a2.091 2.091 0 0 1-.392-1.261 2.23 2.23 0 0 1 .861-1.798 1.96 1.96 0 0 1 .895-.401v-.051a1.758 1.758 0 0 1-1.044-.699 2.047 2.047 0 0 1-.388-1.244 2.037 2.037 0 0 1 .354-1.193 2.45 2.45 0 0 1 .993-.831c.42-.202.899-.303 1.436-.303.531 0 1.006.102 1.423.307.421.202.752.478.993.831.242.349.364.746.367 1.189a2.077 2.077 0 0 1-.401 1.244 1.774 1.774 0 0 1-1.031.699v.051c.326.057.62.19.882.401.264.207.474.467.63.779.16.31.241.65.243 1.019a2.132 2.132 0 0 1-.4 1.261c-.264.37-.631.659-1.1.87-.466.21-1.001.315-1.606.315Zm0-1.078c.361 0 .673-.06.937-.179.265-.122.469-.291.614-.507.145-.219.219-.475.222-.767a1.442 1.442 0 0 0-.239-.806 1.585 1.585 0 0 0-.626-.549 1.983 1.983 0 0 0-.908-.201c-.344 0-.649.067-.916.201a1.58 1.58 0 0 0-.631.549 1.41 1.41 0 0 0-.226.806c-.003.292.067.548.209.767.145.216.351.385.618.507.267.119.582.179.946.179Zm0-4.061c.29 0 .547-.059.771-.175.225-.117.401-.278.529-.486.13-.207.197-.45.2-.729a1.347 1.347 0 0 0-.196-.715 1.24 1.24 0 0 0-.524-.473 1.703 1.703 0 0 0-.78-.171 1.75 1.75 0 0 0-.793.171 1.24 1.24 0 0 0-.524.473 1.314 1.314 0 0 0-.183.715c-.003.279.06.522.187.729.128.208.304.369.529.486.227.116.488.175.784.175Z"
                  fill="#797F8A"
                ></path>
                <path
                  opacity=".5"
                  d="M82.342 124.518v-.955l2.953-3.06c.316-.332.576-.623.78-.873.208-.253.362-.493.465-.72.102-.228.153-.469.153-.725 0-.29-.068-.54-.204-.75a1.34 1.34 0 0 0-.559-.49 1.782 1.782 0 0 0-.797-.175c-.312 0-.585.064-.818.192a1.314 1.314 0 0 0-.537.541 1.707 1.707 0 0 0-.187.819h-1.257c0-.532.122-.996.366-1.394a2.49 2.49 0 0 1 1.006-.925 3.11 3.11 0 0 1 1.453-.332c.548 0 1.031.109 1.449.328.42.216.748.511.984.886.236.373.354.793.354 1.262 0 .324-.061.64-.183.95-.12.31-.328.655-.627 1.036-.298.377-.713.836-1.244 1.376l-1.734 1.815v.064h3.929v1.13h-5.745Zm10.319.119c-.611 0-1.151-.105-1.62-.315-.466-.211-.83-.5-1.095-.87a2.09 2.09 0 0 1-.392-1.261 2.226 2.226 0 0 1 .86-1.798 1.96 1.96 0 0 1 .896-.401v-.051a1.76 1.76 0 0 1-1.044-.699 2.045 2.045 0 0 1-.388-1.244 2.04 2.04 0 0 1 .354-1.193c.241-.353.572-.63.993-.831.42-.202.899-.303 1.436-.303.53 0 1.005.102 1.423.307.42.202.751.478.993.831.241.349.363.746.366 1.189a2.074 2.074 0 0 1-.4 1.244 1.774 1.774 0 0 1-1.032.699v.051c.327.057.621.19.883.401.264.207.474.467.63.779.16.31.24.65.243 1.019a2.137 2.137 0 0 1-.4 1.261c-.265.37-.631.659-1.1.87-.466.21-1.001.315-1.606.315Zm0-1.078c.36 0 .673-.06.937-.179a1.45 1.45 0 0 0 .614-.507c.145-.219.218-.475.221-.767a1.439 1.439 0 0 0-.238-.806 1.588 1.588 0 0 0-.627-.549 1.98 1.98 0 0 0-.907-.201c-.344 0-.65.067-.917.201a1.581 1.581 0 0 0-.63.549 1.408 1.408 0 0 0-.226.806c-.003.292.067.548.209.767.145.216.35.385.618.507.267.119.582.179.945.179Zm0-4.061c.29 0 .546-.059.77-.175.225-.117.401-.278.53-.486.13-.207.197-.45.2-.729a1.346 1.346 0 0 0-.197-.715 1.237 1.237 0 0 0-.524-.473 1.7 1.7 0 0 0-.78-.171c-.3 0-.565.057-.792.171-.224.11-.4.268-.524.473a1.316 1.316 0 0 0-.183.715c-.003.279.06.522.187.729.128.208.304.369.528.486.228.116.49.175.784.175Z"
                  fill="#797F8A"
                ></path>
                <path
                  d="M84.421 83.518h1.465l2.547 6.218h.094l2.547-6.218h1.465v8H91.39v-5.79h-.074l-2.36 5.778h-.953l-2.359-5.781h-.074v5.793H84.42v-8Z"
                  fill="#9CA0A9"
                ></path>
                <path
                  d="m86.637 163.518 3.81-7.535v-.063h-4.406v-1.13h5.77v1.168l-3.797 7.56h-1.377Z"
                  fill="#797F8A"
                ></path>
                <path
                  opacity=".5"
                  d="M43.659 124.518v-.955l2.953-3.06c.315-.332.575-.623.78-.873a3.3 3.3 0 0 0 .464-.72 1.75 1.75 0 0 0 .154-.725c0-.29-.069-.54-.205-.75a1.34 1.34 0 0 0-.558-.49 1.782 1.782 0 0 0-.797-.175c-.313 0-.585.064-.818.192a1.314 1.314 0 0 0-.537.541 1.707 1.707 0 0 0-.188.819H43.65c0-.532.122-.996.367-1.394a2.49 2.49 0 0 1 1.005-.925 3.11 3.11 0 0 1 1.453-.332c.549 0 1.032.109 1.45.328.42.216.748.511.984.886.236.373.353.793.353 1.262 0 .324-.06.64-.183.95-.12.31-.328.655-.626 1.036-.299.377-.713.836-1.245 1.376l-1.734 1.815v.064h3.929v1.13h-5.744Zm7.663 0 3.81-7.535v-.063h-4.407v-1.13h5.77v1.168l-3.796 7.56h-1.377Z"
                  fill="#797F8A"
                ></path>
                <path
                  d="M51.181 85.62a1.141 1.141 0 0 0-.515-.86c-.303-.206-.683-.309-1.141-.309-.328 0-.612.052-.852.156-.24.102-.425.243-.558.422a.996.996 0 0 0-.196.606c0 .19.045.354.133.492.091.138.21.254.356.348.148.09.307.168.476.23.17.06.332.11.489.148l.78.204c.256.062.518.147.786.254.268.106.517.247.746.421.23.175.414.391.555.649.143.258.215.566.215.926 0 .453-.118.855-.352 1.207-.232.351-.569.629-1.012.832-.44.203-.972.304-1.597.304-.6 0-1.117-.095-1.555-.285-.438-.19-.78-.46-1.027-.808-.248-.352-.384-.769-.41-1.25h1.21c.024.289.118.53.282.722.166.19.379.332.636.426.26.091.546.137.856.137.341 0 .644-.054.91-.16.268-.11.48-.26.633-.454.153-.195.23-.423.23-.683a.839.839 0 0 0-.203-.582 1.5 1.5 0 0 0-.543-.375 5.303 5.303 0 0 0-.77-.262l-.945-.258c-.64-.174-1.148-.43-1.523-.77-.372-.338-.559-.786-.559-1.343 0-.46.125-.863.375-1.207.25-.344.589-.61 1.016-.8.427-.193.909-.29 1.445-.29.542 0 1.02.095 1.434.285.417.19.745.452.984.785.24.331.365.712.375 1.141h-1.164Z"
                  fill="#9CA0A9"
                ></path>
                <path
                  d="M46.617 160.731c.005-.284.046-.574.123-.87.08-.295.207-.616.384-.963.176-.346.411-.74.707-1.18l1.981-2.928h1.39l-2.237 3.273c.102-.031.208-.057.32-.077.113-.022.226-.034.34-.034.531 0 1.004.122 1.419.367.415.244.742.578.98 1.001.242.423.362.909.362 1.458 0 .559-.125 1.053-.375 1.482a2.664 2.664 0 0 1-1.022 1.01c-.432.245-.925.367-1.48.367a3.037 3.037 0 0 1-1.482-.362 2.705 2.705 0 0 1-1.035-1.019c-.253-.437-.378-.946-.375-1.525Zm1.274.051c0 .344.068.648.204.912.136.264.327.471.571.622.245.15.526.226.844.226.315 0 .594-.074.835-.222.245-.15.435-.356.571-.618.14-.264.209-.565.209-.903 0-.344-.07-.646-.209-.908a1.523 1.523 0 0 0-1.406-.839c-.318 0-.6.074-.844.221a1.531 1.531 0 0 0-.57.614 1.889 1.889 0 0 0-.205.895ZM163.638 124.518v-.955l2.953-3.06c.316-.332.576-.623.78-.873.208-.253.362-.493.465-.72.102-.228.153-.469.153-.725 0-.29-.068-.54-.204-.75a1.345 1.345 0 0 0-.559-.49 1.777 1.777 0 0 0-.796-.175c-.313 0-.586.064-.819.192a1.314 1.314 0 0 0-.537.541 1.707 1.707 0 0 0-.187.819h-1.257c0-.532.122-.996.366-1.394.245-.398.58-.706 1.006-.925.426-.221.91-.332 1.453-.332.548 0 1.031.109 1.449.328.42.216.749.511.984.886.236.373.354.793.354 1.262 0 .324-.061.64-.183.95-.12.31-.328.655-.627 1.036-.298.377-.713.836-1.244 1.376l-1.734 1.815v.064h3.929v1.13h-5.745Z"
                  fill="#797F8A"
                ></path>
                <path
                  d="m164.047 91.518-2.218-8h1.269l1.559 6.195h.074l1.621-6.195h1.258l1.621 6.199h.074l1.555-6.2h1.273l-2.222 8h-1.215l-1.684-5.992h-.062l-1.684 5.993h-1.219Z"
                  fill="#9CA0A9"
                ></path>
                <path
                  d="M163.578 157.53c0-.559.124-1.054.371-1.483a2.683 2.683 0 0 1 1.018-1.01 2.978 2.978 0 0 1 1.483-.366c.549 0 1.041.122 1.479.366.44.242.787.581 1.04 1.019.255.435.38.942.375 1.521a3.466 3.466 0 0 1-.124.87 5.043 5.043 0 0 1-.383.963c-.176.346-.412.74-.708 1.18l-1.977 2.928h-1.393l2.241-3.277a3.077 3.077 0 0 1-.324.085c-.111.02-.223.03-.337.03a2.754 2.754 0 0 1-1.423-.367 2.653 2.653 0 0 1-.98-1.001c-.239-.424-.358-.909-.358-1.458Zm1.261-.021c0 .344.069.648.205.912.136.261.325.466.567.614.244.147.525.221.844.221a1.533 1.533 0 0 0 1.41-.831c.139-.261.209-.561.209-.899 0-.344-.07-.648-.209-.912a1.553 1.553 0 0 0-.571-.622 1.562 1.562 0 0 0-.839-.226 1.527 1.527 0 0 0-1.411.844 1.919 1.919 0 0 0-.205.899ZM202.361 122.242h1.334c.029.27.121.5.277.69.159.188.367.33.622.426.256.097.54.145.853.145.335 0 .634-.056.899-.17.267-.114.477-.281.63-.503.154-.222.23-.494.23-.818 0-.29-.069-.557-.208-.801a1.478 1.478 0 0 0-.657-.588c-.298-.148-.687-.222-1.167-.222h-.78v-.997l2.097-2.421v-.063h-3.699v-1.13h5.42v.955l-2.335 2.676v.068c.403.026.768.11 1.095.252.33.142.611.329.844.562a2.41 2.41 0 0 1 .724 1.752c0 .502-.133.948-.4 1.338a2.71 2.71 0 0 1-1.104.916c-.466.219-1 .328-1.602.328a3.86 3.86 0 0 1-1.522-.29 2.71 2.71 0 0 1-1.095-.827 2.263 2.263 0 0 1-.456-1.278Z"
                  fill="#797F8A"
                ></path>
                <path
                  d="M202.38 84.557v-1.04h6.192v1.04h-2.496v6.96h-1.203v-6.96h-2.493Z"
                  fill="#9CA0A9"
                ></path>
                <path
                  d="M202.915 154.79v8.728h-1.321v-7.407h-.051l-2.088 1.364v-1.261l2.177-1.424h1.283Zm5.409 8.872c-.673-.002-1.248-.18-1.726-.532-.477-.352-.842-.865-1.095-1.539-.253-.673-.379-1.484-.379-2.433 0-.946.126-1.754.379-2.425.256-.67.622-1.181 1.1-1.534.48-.352 1.054-.528 1.721-.528.668 0 1.24.178 1.718.533.477.352.842.863 1.095 1.534.255.667.383 1.474.383 2.42 0 .952-.126 1.764-.379 2.438-.253.67-.618 1.183-1.095 1.538-.477.352-1.051.528-1.722.528Zm0-1.137c.591 0 1.053-.289 1.385-.865.335-.577.503-1.411.503-2.502 0-.724-.077-1.336-.23-1.836-.151-.503-.368-.884-.652-1.142a1.425 1.425 0 0 0-1.006-.393c-.588 0-1.049.29-1.385.87-.335.579-.504 1.413-.507 2.501 0 .727.075 1.343.226 1.845.153.5.371.88.652 1.138.281.256.619.384 1.014.384ZM241.209 122.813v-1.065l3.418-5.958h1.287l-3.337 5.838v.069h5.182v1.116h-6.55Zm4.138 1.705v-2.02l.017-.495v-2.94h1.231v5.455h-1.248Z"
                  fill="#797F8A"
                ></path>
                <path
                  d="M242.635 91.518v-8h4.961v1.039h-3.754v2.437h3.398v1.035h-3.398v3.489h-1.207Z"
                  fill="#9CA0A9"
                ></path>
                <path
                  d="M242.952 154.79v8.728h-1.321v-7.407h-.051l-2.088 1.364v-1.261l2.178-1.424h1.282Zm5.682 0v8.728h-1.321v-7.407h-.051l-2.088 1.364v-1.261l2.177-1.424h1.283ZM283.478 124.637a3.279 3.279 0 0 1-1.44-.307 2.61 2.61 0 0 1-1.015-.852 2.257 2.257 0 0 1-.404-1.236h1.278c.031.375.197.683.499.925.301.241.662.362 1.082.362.335 0 .632-.077.891-.23.261-.156.466-.371.613-.644a1.89 1.89 0 0 0 .226-.933c0-.355-.077-.672-.23-.95a1.69 1.69 0 0 0-.635-.656 1.786 1.786 0 0 0-.92-.243c-.265 0-.53.045-.797.136-.267.091-.483.21-.648.358l-1.206-.179.49-4.398h4.798v1.13h-3.703l-.277 2.441h.051c.171-.164.397-.302.678-.413.284-.111.588-.166.912-.166a2.67 2.67 0 0 1 2.403 1.415c.242.434.361.934.358 1.5a2.917 2.917 0 0 1-.383 1.512 2.777 2.777 0 0 1-1.066 1.049c-.451.252-.97.379-1.555.379Z"
                  fill="#797F8A"
                ></path>
                <path
                  d="M285.181 85.62a1.142 1.142 0 0 0-.515-.86c-.303-.206-.683-.309-1.141-.309a2.13 2.13 0 0 0-.852.156 1.314 1.314 0 0 0-.558.422.998.998 0 0 0-.196.606c0 .19.045.354.133.492.091.138.21.254.356.348.148.09.307.168.476.23.17.06.332.11.489.148l.781.204c.255.062.517.147.785.254.268.106.517.247.746.421.229.175.414.391.555.649.143.258.215.566.215.926 0 .453-.118.855-.352 1.207-.232.351-.569.629-1.012.832-.44.203-.972.304-1.597.304-.599 0-1.118-.095-1.555-.285-.438-.19-.78-.46-1.027-.808-.248-.352-.384-.769-.411-1.25h1.211c.024.289.118.53.282.722.166.19.379.332.636.426.261.091.546.137.856.137.341 0 .644-.054.91-.16.268-.11.479-.26.633-.454.153-.195.23-.423.23-.683a.836.836 0 0 0-.203-.582 1.502 1.502 0 0 0-.543-.375 5.287 5.287 0 0 0-.769-.262l-.946-.258c-.64-.174-1.148-.43-1.523-.77-.372-.338-.559-.786-.559-1.343 0-.46.125-.863.375-1.207.25-.344.589-.61 1.016-.8.427-.193.909-.29 1.445-.29.542 0 1.02.095 1.434.285.417.19.745.452.984.785.24.331.365.712.375 1.141h-1.164Z"
                  fill="#9CA0A9"
                ></path>
                <path
                  d="M281.108 154.79v8.728h-1.321v-7.407h-.051l-2.088 1.364v-1.261l2.178-1.424h1.282Zm2.371 8.728v-.955l2.953-3.06c.316-.332.576-.623.78-.873.208-.253.362-.493.465-.72.102-.228.153-.469.153-.725 0-.29-.068-.54-.204-.75a1.345 1.345 0 0 0-.559-.49 1.778 1.778 0 0 0-.797-.175c-.312 0-.585.064-.818.192a1.314 1.314 0 0 0-.537.541 1.707 1.707 0 0 0-.187.819h-1.257c0-.532.122-.996.366-1.394.245-.398.58-.706 1.006-.925.426-.221.91-.332 1.453-.332.548 0 1.031.109 1.449.328.42.216.748.511.984.886.236.373.354.793.354 1.262 0 .324-.061.64-.183.95-.12.31-.328.655-.627 1.036-.298.377-.713.836-1.244 1.376l-1.734 1.815v.064h3.929v1.13h-5.745Z"
                  fill="#797F8A"
                ></path>
                <defs>
                  <filter
                    id="filter0_d_212_2660"
                    x=".979"
                    y=".018"
                    width="331"
                    height="81"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2660"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2660"
                      result="shape"
                    ></feBlend>
                  </filter>
                  <filter
                    id="filter1_d_212_2660"
                    x=".979"
                    y="48.018"
                    width="331"
                    height="165"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2660"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2660"
                      result="shape"
                    ></feBlend>
                  </filter>
                  <clipPath id="clip0_212_2660">
                    <path
                      fill="#fff"
                      transform="translate(33.478 26.518)"
                      d="M0 0h24v24H0z"
                    ></path>
                  </clipPath>
                </defs>
              </svg>

              <svg
                className="absolute top-20 left-[18%] -rotate-2 hidden xl:block"
                width="332"
                height="222"
                viewBox="0 0 332 222"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_212_2543)">
                  <rect
                    x="21.053"
                    y="19.006"
                    width="290"
                    height="180"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <rect
                    x="21.053"
                    y="19.006"
                    width="290"
                    height="180"
                    rx="10"
                    stroke="#E3E5EA"
                  ></rect>
                </g>
                <path
                  d="M21.053 29.006c0-5.523 4.477-10 10-10h270c5.523 0 10 4.477 10 10v30h-290v-30Z"
                  fill="#fff"
                  stroke="#E3E5EA"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M70.403 32.922h3.317a.75.75 0 1 1 0 1.5h-2.748l-2.291 9.167h2.372a.75.75 0 0 1 0 1.5h-6.666a.75.75 0 0 1 0-1.5h2.747l2.292-9.167h-2.373a.75.75 0 0 1 0-1.5H70.403ZM92.97 36.339a3.417 3.417 0 0 1 3.416-3.417h1.333a3.417 3.417 0 0 1 3.417 3.417.75.75 0 0 1-1.5 0 1.917 1.917 0 0 0-1.917-1.917h-1.333a1.917 1.917 0 0 0-1.856 2.397.75.75 0 0 1-1.453.374 3.422 3.422 0 0 1-.108-.854Zm-2.667 2.667a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-2.505a3.417 3.417 0 0 1-2.829 5.333h-1.333a3.417 3.417 0 0 1-3.417-3.417.75.75 0 0 1 1.5 0c0 1.059.858 1.917 1.917 1.917h1.333a1.917 1.917 0 1 0 0-3.833h-6.666a.75.75 0 0 1-.75-.75ZM122.469 33.672a.75.75 0 1 0-1.5 0v4.667a4.084 4.084 0 0 0 8.167 0v-4.667a.75.75 0 0 0-1.5 0v4.667a2.584 2.584 0 0 1-5.167 0v-4.667Zm-1.416 9.917a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5h-8ZM158.298 33.761a4.084 4.084 0 0 0-5.775 0l-.471.472a.75.75 0 1 0 1.06 1.06l.472-.471a2.583 2.583 0 1 1 3.653 3.653l-1.124 1.124a2.327 2.327 0 0 1-3.291 0l-.181-.181a.75.75 0 0 0-1.061 1.06l.182.182a3.827 3.827 0 0 0 5.412 0l1.124-1.124a4.083 4.083 0 0 0 0-5.775Zm-8.304 4.65a2.327 2.327 0 0 1 3.291 0l.181.182a.75.75 0 0 0 1.061-1.06l-.182-.182a3.827 3.827 0 0 0-5.412 0l-1.124 1.124a4.084 4.084 0 0 0 5.775 5.775l.471-.471a.75.75 0 1 0-1.06-1.061l-.472.471a2.583 2.583 0 1 1-3.653-3.653l1.124-1.124ZM260.25 32.475a.75.75 0 0 1 0 1.06l-1.387 1.387h6.19a4.75 4.75 0 0 1 0 9.5h-2.667a.75.75 0 0 1 0-1.5h2.667a3.25 3.25 0 1 0 0-6.5h-6.19l1.387 1.387a.75.75 0 1 1-1.061 1.06l-2.667-2.666a.752.752 0 0 1 0-1.061l2.667-2.667a.75.75 0 0 1 1.061 0ZM293.856 32.475a.75.75 0 0 1 1.06 0l2.667 2.667a.75.75 0 0 1 0 1.06l-2.667 2.667a.75.75 0 1 1-1.06-1.06l1.386-1.387h-6.189a3.25 3.25 0 1 0 0 6.5h2.666a.75.75 0 1 1 0 1.5h-2.666a4.75 4.75 0 1 1 0-9.5h6.189l-1.386-1.386a.75.75 0 0 1 0-1.06ZM37.794 32.922a1.49 1.49 0 0 0-1.491 1.491V43.45c0 .905.733 1.639 1.639 1.639h4.444a3.417 3.417 0 0 0 1.303-6.576 3.417 3.417 0 0 0-2.636-5.59h-3.26Zm3.259 6.834h-3.25v3.694c0 .077.062.139.139.139h4.444a1.917 1.917 0 0 0 0-3.833h-1.333Zm0-1.5a1.917 1.917 0 1 0 0-3.834h-3.25v3.834h3.25Z"
                  fill="#9DA3AE"
                ></path>
                <defs>
                  <filter
                    id="filter0_d_212_2543"
                    x=".553"
                    y=".506"
                    width="331"
                    height="221"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2543"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2543"
                      result="shape"
                    ></feBlend>
                  </filter>
                </defs>
              </svg>

              <svg
                className="absolute top-24 left-[38%]"
                width="368"
                height="190"
                viewBox="0 0 368 190"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  filter="url(#filter0_d_212_2572)"
                  transform="rotate(-2 49.217 117.228)"
                >
                  <rect
                    x="49.217"
                    y="117.228"
                    width="290"
                    height="50"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <rect
                    x="49.217"
                    y="117.228"
                    width="290"
                    height="50"
                    rx="10"
                    stroke="#E3E5EA"
                  ></rect>
                </g>
                <circle
                  opacity=".1"
                  cx="81.071"
                  cy="141.131"
                  r="15"
                  transform="rotate(-2 81.071 141.131)"
                  fill="#EF4444"
                ></circle>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M311.241 128.56a.75.75 0 0 1 1.06-.037l3.589 3.346 3.346-3.588a.75.75 0 1 1 1.097 1.023l-3.346 3.588 3.588 3.347a.75.75 0 1 1-1.023 1.097l-3.588-3.347-3.347 3.589a.75.75 0 1 1-1.097-1.023l3.347-3.589-3.589-3.346a.75.75 0 0 1-.037-1.06Z"
                  fill="#D1D5DB"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M72.826 141.419a8.25 8.25 0 1 1 16.49-.576 8.25 8.25 0 0 1-7.957 8.533 8.25 8.25 0 0 1-8.533-7.957Zm7.904-10.032c-5.381.188-9.591 4.703-9.403 10.084.188 5.382 4.702 9.592 10.084 9.404 5.381-.188 9.592-4.703 9.404-10.084-.188-5.382-4.703-9.592-10.085-9.404Zm-2.25 6.302a.75.75 0 0 0-1.024 1.097l2.555 2.382-2.382 2.554a.75.75 0 1 0 1.097 1.023l2.382-2.554 2.554 2.382a.75.75 0 1 0 1.023-1.097l-2.554-2.382 2.382-2.554a.75.75 0 1 0-1.097-1.023l-2.382 2.554-2.555-2.382Z"
                  fill="#EF4444"
                ></path>
                <rect
                  opacity=".2"
                  x="111.771"
                  y="132.054"
                  width="100"
                  height="16"
                  rx="4"
                  transform="rotate(-2 111.771 132.054)"
                  fill="#EF4444"
                ></rect>
                <g
                  filter="url(#filter1_d_212_2572)"
                  transform="rotate(-1 21 68.115)"
                >
                  <rect
                    x="21"
                    y="68.115"
                    width="290"
                    height="50"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <rect
                    x="21"
                    y="68.115"
                    width="290"
                    height="50"
                    rx="10"
                    stroke="#E3E5EA"
                  ></rect>
                </g>
                <circle
                  opacity=".1"
                  cx="52.431"
                  cy="92.57"
                  r="15"
                  transform="rotate(-1 52.431 92.57)"
                  fill="#10B981"
                ></circle>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M44.184 92.714a8.25 8.25 0 1 1 16.497-.288 8.25 8.25 0 0 1-16.497.288Zm8.078-9.892c-5.384.093-9.672 4.534-9.578 9.918.094 5.384 4.535 9.673 9.919 9.579 5.383-.094 9.672-4.535 9.578-9.92-.094-5.383-4.535-9.671-9.919-9.578Zm4.657 7.2a.75.75 0 0 0-1.08-1.042l-4.39 4.547-1.495-1.444a.75.75 0 0 0-1.042 1.079l2.034 1.965a.75.75 0 0 0 1.06-.019l4.913-5.086Z"
                  fill="#10B981"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M282.788 84.018a.75.75 0 0 1 1.06-.019l3.53 3.41 3.409-3.53a.75.75 0 1 1 1.079 1.041l-3.409 3.53 3.53 3.409a.75.75 0 0 1-1.042 1.079l-3.53-3.409-3.408 3.53a.75.75 0 0 1-1.079-1.042l3.408-3.53-3.53-3.408a.75.75 0 0 1-.018-1.061Z"
                  fill="#D1D5DB"
                ></path>
                <rect
                  opacity=".2"
                  x="83.287"
                  y="84.03"
                  width="80"
                  height="16"
                  rx="4"
                  transform="rotate(-1 83.287 84.03)"
                  fill="#10B981"
                ></rect>
                <g
                  filter="url(#filter2_d_212_2572)"
                  transform="rotate(1 56.873 19)"
                >
                  <rect
                    x="56.873"
                    y="19"
                    width="290"
                    height="50"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <rect
                    x="56.873"
                    y="19"
                    width="290"
                    height="50"
                    rx="10"
                    stroke="#E3E5EA"
                  ></rect>
                </g>
                <circle
                  opacity=".1"
                  cx="87.431"
                  cy="44.537"
                  r="15"
                  transform="rotate(1 87.431 44.537)"
                  fill="#0EA5E9"
                ></circle>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M87.576 36.288a8.25 8.25 0 1 0-.288 16.498 8.25 8.25 0 0 0 .288-16.498Zm-9.893 8.079c.094-5.384 4.535-9.672 9.919-9.578 5.384.093 9.672 4.534 9.578 9.918-.094 5.384-4.534 9.673-9.918 9.579-5.384-.094-9.673-4.535-9.579-9.92Zm9.78-1.58a.75.75 0 0 1 .736.763l-.087 5a.75.75 0 1 1-1.5-.027l.087-4.999a.75.75 0 0 1 .763-.737Zm.021-1.25a1 1 0 1 0 .035-2 1 1 0 0 0-.035 2Z"
                  fill="#0EA5E9"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M317.946 44.03a.75.75 0 0 1 1.061.018l3.408 3.53 3.53-3.409a.75.75 0 0 1 1.042 1.08l-3.53 3.408 3.409 3.53a.75.75 0 0 1-1.079 1.042l-3.409-3.53-3.529 3.409a.75.75 0 0 1-1.042-1.08l3.529-3.408-3.408-3.53a.75.75 0 0 1 .018-1.06Z"
                  fill="#D1D5DB"
                ></path>
                <rect
                  opacity=".2"
                  x="118.566"
                  y="37.079"
                  width="120"
                  height="16"
                  rx="4"
                  transform="rotate(1 118.566 37.08)"
                  fill="#0EA5E9"
                ></rect>
                <defs>
                  <filter
                    id="filter0_d_212_2572"
                    x="29.061"
                    y="88.95"
                    width="331.881"
                    height="100.405"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2572"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2572"
                      result="shape"
                    ></feBlend>
                  </filter>
                  <filter
                    id="filter1_d_212_2572"
                    x=".674"
                    y="44.727"
                    width="331.482"
                    height="95.707"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2572"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2572"
                      result="shape"
                    ></feBlend>
                  </filter>
                  <filter
                    id="filter2_d_212_2572"
                    x="35.674"
                    y=".673"
                    width="331.482"
                    height="95.708"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2572"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2572"
                      result="shape"
                    ></feBlend>
                  </filter>
                </defs>
              </svg>

              <svg
                className="absolute top-80 -left-16 hidden -rotate-1 xl:block"
                width="333"
                height="127"
                viewBox="0 0 333 127"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  filter="url(#filter0_d_212_2720)"
                  transform="rotate(-1 21 24.061)"
                >
                  <rect
                    x="21"
                    y="24.061"
                    width="290"
                    height="80"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <rect
                    x="21"
                    y="24.061"
                    width="290"
                    height="80"
                    rx="10"
                    stroke="#E3E5EA"
                  ></rect>
                </g>
                <rect
                  opacity=".1"
                  x="40.26"
                  y="38.727"
                  width="120"
                  height="20"
                  rx="8"
                  transform="rotate(-1 40.26 38.727)"
                  fill="#797F8A"
                  stroke="#fff"
                ></rect>
                <rect
                  opacity=".1"
                  x="40.748"
                  y="66.723"
                  width="67"
                  height="20"
                  rx="8"
                  transform="rotate(-1 40.748 66.723)"
                  fill="#797F8A"
                  stroke="#fff"
                ></rect>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M282.788 39.965a.75.75 0 0 1 1.06-.019l3.53 3.409 3.409-3.53a.75.75 0 1 1 1.079 1.042l-3.409 3.53 3.53 3.408a.75.75 0 0 1-1.042 1.08l-3.53-3.41-3.408 3.53a.75.75 0 0 1-1.079-1.042l3.408-3.53-3.53-3.408a.75.75 0 0 1-.018-1.06Z"
                  fill="#D1D5DB"
                ></path>
                <defs>
                  <filter
                    id="filter0_d_212_2720"
                    x=".674"
                    y=".673"
                    width="332.006"
                    height="125.703"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2720"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2720"
                      result="shape"
                    ></feBlend>
                  </filter>
                </defs>
              </svg>

              <svg
                className="absolute top-80 -right-12 hidden xl:block"
                width="332"
                height="82"
                viewBox="0 0 332 82"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_212_2611)">
                  <rect
                    x="21"
                    y="19"
                    width="290"
                    height="40"
                    rx="10"
                    fill="#fff"
                  ></rect>
                  <rect
                    x="21"
                    y="19"
                    width="290"
                    height="40"
                    rx="10"
                    stroke="#E3E5EA"
                  ></rect>
                </g>
                <rect
                  opacity=".4"
                  x="33"
                  y="29"
                  width="80"
                  height="20"
                  rx="10"
                  fill="#D2D5DA"
                ></rect>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M94.47 35.47a.75.75 0 0 1 1.06 0L98 37.94l2.47-2.47a.75.75 0 1 1 1.06 1.06L99.06 39l2.47 2.47a.75.75 0 1 1-1.06 1.06L98 40.06l-2.47 2.47a.75.75 0 1 1-1.06-1.06L96.94 39l-2.47-2.47a.75.75 0 0 1 0-1.06Z"
                  fill="#D1D5DB"
                ></path>
                <rect
                  opacity=".4"
                  x="121"
                  y="29"
                  width="68"
                  height="20"
                  rx="10"
                  fill="#D2D5DA"
                ></rect>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M173.47 35.47a.75.75 0 0 1 1.06 0l2.47 2.47 2.47-2.47a.75.75 0 1 1 1.06 1.06L178.061 39l2.469 2.47a.75.75 0 1 1-1.06 1.06L177 40.06l-2.47 2.47a.75.75 0 1 1-1.06-1.06l2.469-2.47-2.469-2.47a.75.75 0 0 1 0-1.06Z"
                  fill="#D1D5DB"
                ></path>
                <rect
                  opacity=".4"
                  x="197"
                  y="29"
                  width="92"
                  height="20"
                  rx="10"
                  fill="#D2D5DA"
                ></rect>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M273.47 35.47a.75.75 0 0 1 1.06 0l2.47 2.47 2.47-2.47a.75.75 0 1 1 1.06 1.06L278.061 39l2.469 2.47a.75.75 0 1 1-1.06 1.06L277 40.06l-2.47 2.47a.75.75 0 1 1-1.06-1.06l2.469-2.47-2.469-2.47a.75.75 0 0 1 0-1.06Z"
                  fill="#D1D5DB"
                ></path>
                <defs>
                  <filter
                    id="filter0_d_212_2611"
                    x=".5"
                    y=".5"
                    width="331"
                    height="81"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="10"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix values="0 0 0 0 0.180392 0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0.07 0"></feColorMatrix>
                    <feBlend
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_212_2611"
                    ></feBlend>
                    <feBlend
                      in="SourceGraphic"
                      in2="effect1_dropShadow_212_2611"
                      result="shape"
                    ></feBlend>
                  </filter>
                </defs>
              </svg>
            </div>
            <section className="relative mx-auto max-w-6xl px-4 pt-16 pb-20 sm:pt-24 lg:pt-64 lg:pb-48">
              <div className="text-center">
                <h1 className="text-4xl font-extrabold tracking-tight text-[#2E3440] sm:text-5xl md:text-6xl">
                  组件库
                </h1>
                <p className="mx-auto mt-3 max-w-md text-base text-gray-500 sm:text-lg md:mt-5 md:max-w-3xl md:text-xl">
                  收集技术前沿使用的组件，避免工作中重复造轮子，使用优秀的组件，站在巨人的肩膀上，提升工作效率！
                </p>
                {/* <Typography
                variant="h1"
                className="pb-10 font-semibold tracking-normal text-[#1A237E]"
              >
                组件库
              </Typography> 
              <Typography
                variant="h5"
                className=" text-[#1A237E]/60"
              ></Typography>*/}
              </div>
            </section>
          </div>

          <section>
            <div className="relative max-w-screen-xl mx-auto">
              <div className="relative max-w-screen-lg mx-auto ">
                <div className="py-5">筛选条件</div>
                <div className="py-10 grid grid-cols-3 gap-10">
                  <ProductCard items={CardItems} />
                </div>
                <div className="relative text-center py-10">
                  <button className="px-8 py-4 font-semibold text-sm bg-blue-500 text-white rounded-md shadow-sm hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 ease-in-out delay-150 duration-300">
                    查看更多
                  </button>
                </div>
              </div>
            </div>
          </section>
        </main>
      </CommonLayout>
    </>
  );
}
